import { Layout } from 'antd';
import CambiarClave from 'components/CambiarClave';
import ElegirFilialUsuario from 'components/ElegirFilialUsuario';
import Loading from 'components/Loading';
import { IS_FILIAL_SELECTED } from 'constants/auth';
import useAuth from 'hooks/useAuth';
import { Suspense, useEffect, useState } from 'react';
import SimpleBar from 'simplebar-react';
import Footer from './Footer';
import Header from './Header';
import Sidebar from './Sidebar';

const AppLayout = ({ children }) => {
  const { Content } = Layout;

  const [collapsed, setCollapsed] = useState(false);
  const { usuario, loading } = useAuth();
  
  const [openFiliales, setOpenFiliales] = useState(false);
  const isFilialSelected = localStorage.getItem(IS_FILIAL_SELECTED);

  useEffect(() => {
    if (!usuario) return;

    setOpenFiliales(usuario?.filiales?.length > 1 && !isFilialSelected);
  }, [usuario]);

  if (!usuario || loading) {
    return <Loading fullscreen />
  }

  return (
    <Layout>
      {usuario.cambiarcontraseña &&
        <CambiarClave />
      }
      {openFiliales &&
        <ElegirFilialUsuario
          filiales={usuario?.filiales}
          usuarioId={usuario?.id}
        />
      }
      <Sidebar collapsed={collapsed} />
      <Layout>
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content>
          <Suspense fallback={<Loading />}>
            <SimpleBar>
              {children}
            </SimpleBar>
          </Suspense>
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

export default AppLayout